<template>
  <b-sidebar
    v-if="sidebarWidth !== ''"
    id="special-condition-price-sidebar"
    bg-variant="white"
    right
    lazy
    backdrop
    no-header
    no-close-on-backdrop
    @shown="getData"
    @hidden="resetSidebarData"
    shadow
    :width="sidebarWidth"
    ref="conditionPriceSidebar"
    :title="addPrice ? 'Добавление спецусловия' : 'Редактирование спецусловия'">
    <template v-slot:default="{ hide }">
      <b-container fluid>
        <b-button-close @click="hide()"></b-button-close>
        <b-form @submit.stop.prevent="saveFormData" autocomplete="off">
          <h2 v-if="addPrice" class="my-4">Добавление спецусловия</h2>
          <h2 v-else class="my-4">Редактирование спецусловия</h2>
          <b-row>
            <b-col md="3">
              <b-form-group
                label="Организация"
                label-for="dealerClient"
                label-class="mf-label"
                :invalid-feedback="getError('dealer')"
              >
                <treeselect
                  id="dealerClient"
                  name="dealerClient"
                  :options="dealerClients"
                  v-model="clientsModel"
                  noResultsText="Ничего не найдено..."
                  :clearable=true
                  placeholder="Выбрать..."
                  label="Организация"
                  :disabled="disabled || !addPrice"
                  data-vv-as="Организация"
                  v-validate="{required:true}"
                >
                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.name }}</div>
                </treeselect>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Месяц начала применения"
                label-for="dateStart"
                label-class="mf-label"
              >
                <a-month-picker
                  id="dateStart-specialConditionPrice"
                  v-model="dateStart"
                  :disabled="disabled"
                  format="MM/YYYY"
                  placeholder="Дата"/>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="% вознаграждения"
                label-for="percentCompensation-input"
                label-class="mf-label"
                :invalid-feedback="getError('% вознаграждения')"
                style="margin-bottom: 0">
                <b-form-input
                  id="percentCompensation-input"
                  name="% вознаграждения"
                  v-validate="priceValidation"
                  data-vv-as="% вознаграждения"
                  v-model="percentCompensation"
                  :disabled="disabled"
                  :state="validateState('% вознаграждения')"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3" class="d-flex align-items-end mb-4">
              <b-button :disabled="disabled" @click="recalcPrices" variant="outline-primary" v-b-tooltip title="Рассчитать"><i class="fas fa-calculator"></i></b-button>
            </b-col>
          </b-row>
          <h4 class="form-title">Спецусловия</h4>
          <b-row v-for="(item, index) in modelPrice" :key="index + key">
            <b-col md="3">
              <b-form-group
                :label="(index === 0) ? ('Тип пакета') : ''"
                :label-for="'packageTypes-' + index"
                label-class="mf-label"
                :invalid-feedback="getError('Тип пакета-' + index)"
              >
                <treeselect
                  :id="'packageTypes-' + index"
                  :name="'Тип пакета-' + index"
                  :options="messagePricePositions.spec_condition"
                  v-model="item.packageName"
                  noResultsText="Ничего не найдено..."
                  :clearable=true
                  placeholder="Выбрать..."
                  :label="'Тип пакета-' + index"
                  :data-vv-as="'Тип пакета-' + index"
                  :disabled="disabled"
                  v-validate="{required:true}"
                >
                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.caption }}</div>
                </treeselect>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="(index === 0) ? ('Стоимость') : ''"
                :label-for="'packageTypes-' + index"
                label-class="mf-label"
                :invalid-feedback="getError('Стоимость-' + index)"
              >
                <b-form-input
                  :id="'percentPackages-input-' + index"
                  :name="'Стоимость-' + index"
                  v-validate="priceValidation"
                  :data-vv-as="'Стоимость-' + index"
                  v-model="item.priceDefault"
                  :disabled="disabled"
                  placeholder=""
                  :state="validateState('Стоимость-' + index)"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                :label="(index === 0) ? ('Вознаграждение') : ''"
                :label-for="'packageTypes-' + index"
                label-class="mf-label"
                :invalid-feedback="getError('Вознаграждение-' + index)"
              >
                <b-form-input
                  :id="'percentPackages-input-' + index"
                  :name="'Вознаграждение-' + index"
                  v-validate="priceValidation"
                  :data-vv-as="'Вознаграждение-' + index"
                  v-model="item.priceRecalc"
                  :disabled="disabled"
                  placeholder=""
                  :state="validateState('Вознаграждение-' + index)"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-button :disabled="disabled" size="sm" variant="outline-secondary" class="mr-3" @click="addPackageType"><i class="fas fa-plus"></i></b-button>
              <b-button :disabled="disabled" size="sm" variant="outline-secondary" @click="deletePackageType"><i class="fas fa-minus"></i></b-button>
            </b-col>
          </b-row>
          <b-row class="mb-3 mt-3">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12">
              <div class="d-md-flex d-lg-flex align-items-start">
                <b-button
                  :disabled="veeErrors.any() || (Boolean(dateStart) === false) || disabled"
                  variant="success"
                  type="submit"
                  class="btn-action-success mr-3 mb-2">
                  <span v-if="addPrice">Добавить спецусловие</span>
                  <span v-else>Изменить спецусловие</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </template>
  </b-sidebar>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { validation } from '../modalForms/validation'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from 'moment'

export default {
  name: 'AddSpecialConditionPrice',
  components: {
    Treeselect
  },
  props: ['addPrice', 'startMonth', 'startYear', 'disabled', 'clientId'],
  mixins: [validation],
  data () {
    return {
      sidebarWidth: '',
      dateStart: null,
      clientsModel: null,
      percentCompensation: null,
      fields: [
        { key: 'packageName', label: 'Тип пакета' },
        { key: 'priceDefault', label: 'Стоимость тарифа' },
        { key: 'priceRecalc', label: 'Стоимость тарифа вознаграждение' }
      ],
      modelPrice: [
        { packageName: null, priceDefault: null, priceRecalc: null }
      ],
      oldStartMonth: null,
      oldStartYear: null,
      key: Math.random()
    }
  },
  mounted () {
    this.calcSidebarWidth()
  },
  computed: {
    ...mapState(
      {
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop,
        dealerPriceData: state => state.dealers.dealerPriceData,
        dealerClients: state => state.dealers.dealerClients,
        messagePricePositions: state => state.dealers.messagePricePositions,
        dealerSpecCondition: state => state.dealers.dealerSpecCondition
      }
    )
  },
  methods: {
    addPackageType () {
      this.modelPrice.push({ packageName: null, priceDefault: null, priceRecalc: null })
    },
    deletePackageType () {
      if (this.modelPrice.length > 1) {
        this.modelPrice.splice((this.modelPrice.length - 1), 1)
      }
    },
    percentage (percent, total) {
      return ((percent / 100) * total).toFixed(2)
    },
    recalcPrices () {
      this.modelPrice.map((item) => {
        item.priceRecalc = parseFloat(this.percentage(this.percentCompensation, item.priceDefault))
      })
      this.key = Math.random()
    },
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    calcSidebarWidth () {
      if (this.largeDesktop) {
        this.sidebarWidth = '50%'
      } else if (this.desktop) {
        this.sidebarWidth = '100%'
      } else if (this.mobile || this.tablet) {
        this.sidebarWidth = '100%'
      }
    },
    resetSidebarData () {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
      setTimeout(() => {
        this.dateStart = null
        this.clientsModel = null
        this.percentCompensation = null
        this.modelPrice = [
          { packageName: null, priceDefault: null, priceRecalc: null }
        ]
      }, 200)
    },
    getData () {
      this.getDealerClients({ id: this.$route.params.id })
      this.getMessagePricePositions()
      if (!this.addPrice) {
        this.clientsModel = this.clientId
        this.getDealerSpecPrice({ client_id: this.clientId, month: this.startMonth, year: this.startYear, type: 'spec_condition' }).then(
          () => {
            const dt = this.startYear + '-' + (this.startMonth.length > 0 ? this.startMonth : ('0' + this.startMonth)) + '-' + '01'
            this.dateStart = moment(dt)
            this.oldStartMonth = this.startMonth
            this.oldStartYear = this.startYear
            this.dealerPriceData.packages.map((item) => {
              item.packageName = item.message_price_position_alias
              item.priceDefault = item.client_points_cost
              item.priceRecalc = item.daobit_points_cost
              return item
            })
            this.modelPrice = this.dealerPriceData.packages
            this.calcPackagesPercent()
          }
        )
      } else {
        this.dateStart = null
      }
    },
    calcPackagesPercent () {
      const percents = []
      this.dealerPriceData.packages.map((item) => {
        percents.push(parseFloat((item.daobit_points_cost * 100 / item.client_points_cost).toFixed(2)))
        percents.push(parseFloat((item.daobit_points_cost * 100 / item.client_points_cost).toFixed(2)))
      })
      const counts = {}
      percents.forEach(function (x) { counts[x] = (counts[x] || 0) + 1 })
      this.percentCompensation = Object.keys(counts)[0]
    },
    saveFormData () {
      console.log('saveFormData')
      const data = {
        client_id: this.clientsModel,
        year: null,
        month: null,
        year_new: null,
        month_new: null,
        packages: []
      }
      this.modelPrice.map((item) => {
        data.packages.push({ message_price_position_alias: item.packageName, client_points_cost: parseFloat(item.priceDefault), daobit_points_cost: item.priceRecalc })
        return item
      })

      const year = this.dateStart.toDate().getFullYear()
      const month = this.dateStart.toDate().getMonth() + 1

      if (this.addPrice) {
        data.year = year
        data.month = month
      } else {
        data.year_new = year
        data.month_new = month
        data.year = this.oldStartYear
        data.month = this.oldStartMonth
      }

      console.log('data ', data)

      if (this.addPrice) {
        this.saveDealerSpecPrice({ data: data, type: 'spec_condition' }).then(
          (response) => {
            console.log('response ', response)
            this.getDealerSpecialPrices({ id: this.$route.params.id })
            this.$refs.conditionPriceSidebar.hide()
          }
        )
      } else {
        this.updateDealerSpecPrice({ data: data, type: 'spec_condition' }).then(
          () => {
            this.getDealerSpecialPrices({ id: this.$route.params.id })
            this.$refs.conditionPriceSidebar.hide()
          }
        )
      }
    },
    ...mapActions('dealers', [
      'getDealerClients',
      'getMessagePricePositions',
      'saveDealerSpecPrice',
      'updateDealerSpecPrice',
      'getDealerSpecialPrices',
      'getDealerSpecPrice'
    ]),
    ...mapMutations('dealers', [
      'setPrice'
    ])
  }
}
</script>

<style scoped>
  .form-control:disabled {
      background-color: #f5f5f5;
  }
</style>
